const LOAD_TAG = 'report/LOAD_TAG'

export const types = { LOAD_TAG }

export const loadTag = (tag, dictionaries) => ({ type: LOAD_TAG, tag, dictionaries })
